// Advanced-filter URL params for /conversations deep linking.
// Legacy /conversations mapping stays in queryMapping.js.
export const ADVANCED_CONVERSATION_QUERY_FILTERS = {
  active: 'active',
  queued: 'queued',
  ai_served: 'ai_served',
  agent_served: 'agent_served',
  unlocked: 'unlocked',
  unresponded: 'unresponded',
  typed: 'typed',
  i_am_primary: 'i_am_primary',
  query: 'query',
  search_type: 'search_type',
  search: 'search',
  message_content: 'message_content',
  name: 'name',
  email: 'email',
  phone: 'phone',
  tag_names: 'tag_names',
  category_names: 'category_names',
  customer_segments: 'customer_segments',
  teams: 'teams',
  agent_teams: 'agent_teams',
  agent: 'agent',
  date_range: 'date_range',
  last_feedback_score: 'last_feedback_score',
};
